__turbopack_context__.v({
  "arcCircle": "BatterySection-module__AUC2mW__arcCircle",
  "arcSvg": "BatterySection-module__AUC2mW__arcSvg",
  "bgWrapper": "BatterySection-module__AUC2mW__bgWrapper",
  "chargingLabel": "BatterySection-module__AUC2mW__chargingLabel",
  "counter": "BatterySection-module__AUC2mW__counter",
  "daysLabel": "BatterySection-module__AUC2mW__daysLabel",
  "desktopBgImage": "BatterySection-module__AUC2mW__desktopBgImage",
  "dialContainer": "BatterySection-module__AUC2mW__dialContainer",
  "drawArc": "BatterySection-module__AUC2mW__drawArc",
  "glassCircle": "BatterySection-module__AUC2mW__glassCircle",
  "labelStack": "BatterySection-module__AUC2mW__labelStack",
  "midArc": "BatterySection-module__AUC2mW__midArc",
  "mobileBgImage": "BatterySection-module__AUC2mW__mobileBgImage",
  "scrollWrapper": "BatterySection-module__AUC2mW__scrollWrapper",
  "section": "BatterySection-module__AUC2mW__section",
  "stickyContainer": "BatterySection-module__AUC2mW__stickyContainer",
  "textContent": "BatterySection-module__AUC2mW__textContent",
  "uptoLabel": "BatterySection-module__AUC2mW__uptoLabel" + " " + __turbopack_context__.i(515534)["sectionLabel"],
});
